// Existing engagement-plan command made available from engagement-bound
// activity conversations. It still travels through the normal screen
// allowlist and server capability executor.
export const ADD_ACTIVITY_TO_PLAN_CAPABILITY_ID = 'engagement-brief.pull_in_activity';
